import * as firebase from "firebase";

export const uploadFile = async (
  storageRef: firebase.storage.Reference,
  file: File,
  onProgress?: (progress: number) => void
): Promise<firebase.storage.Reference> => {
  return new Promise((resolve, reject) => {
    const metadata = {
      contentType: file.type
    } as firebase.storage.UploadMetadata;

    // Upload file and metadata
    const uploadTask: firebase.storage.UploadTask = storageRef
      .child(file.name)
      .put(file, metadata);
    // Listen for state changes, errors, and completion of the upload.
    uploadTask.on(
      firebase.storage.TaskEvent.STATE_CHANGED, // or 'state_changed'
      function(snapshot: firebase.storage.UploadTaskSnapshot) {
        // Get task progress, including the number of bytes uploaded and the total number of bytes to be uploaded
        const progress =
          (snapshot.bytesTransferred / snapshot.totalBytes) * 100;
        if (typeof onProgress === "function") {
          onProgress(progress);
        }
        console.log("Upload is " + progress + "% done");
        switch (snapshot.state) {
          case firebase.storage.TaskState.PAUSED: // or 'paused'
            console.log("Upload is paused");
            break;
          case firebase.storage.TaskState.RUNNING: // or 'running'
            console.log("Upload is running");
            break;
        }
      },
      //@ts-ignore
      function(error: firebase.FirebaseError) {
        // A full list of error codes is available at
        // https://firebase.google.com/docs/storage/web/handle-errors
        switch (error.code) {
          case "storage/unauthorized":
            // User doesn't have permission to access the object
            break;

          case "storage/canceled":
            // User canceled the upload
            break;

          case "storage/unknown":
            // Unknown error occurred, inspect error.serverResponse
            break;
        }
        reject(error);
      },
      function() {
        // Upload completed successfully, now we can get the download URL
        resolve(uploadTask.snapshot.ref);
      }
    );
  });
};

export default uploadFile;
